@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-radius: 16px;
    background: mixins.get-color(background, bg-gray-100);
    text-align: center;

    @include mixins.container-desktop-and-up {
        position: relative;
        flex: 1;
        background: transparent;
        border-radius: 0;
        margin: 0 auto;

        &::after {
            content: " ";
            position: absolute;
            right: 0;
            top: 16px;
            bottom: 16px;
            margin: auto;
            width: 1px;
            background-color: mixins.get-color(border, border-secondary);
        }
    }
}

:host(:last-child) {
    @include mixins.container-desktop-and-up {
        &::after {
            display: none;
        }
    }
}

.stat-box {
    &__value {
        font-size: 20px;
        line-height: 30px;
        font-weight: 900;
        color: mixins.get-color(text, text-primary);
    }

    &__label {
        font-size: 14px;
        line-height: 20px;
        color: mixins.get-color(text, text-primary);
    }
}
